module.exports = __webpack_public_path__ + "static/location-map-57adc99b38cb2bc7d81656980d63170c.jpg";